import { clickButtonOnProductComparisonEvent } from '@main/core/tagging/tagging';
export function tagging() {
    return {
        publish: function (ev, resultData) {
            if (ev === 'learnMoreButton_click') {
                {
                    var label = (resultData === null || resultData === void 0 ? void 0 : resultData.learnMoreURL) || '';
                    clickButtonOnProductComparisonEvent(label, {
                        name: 'componentevent',
                        componentName: 'finance-table',
                        componentGroup: 'product-general',
                        action: 'click-product',
                        label: label,
                    });
                }
            }
        }
    };
}
